import * as XLSX from 'xlsx';
import {getWorkbookSheets} from './workbookModel';
import {createSpreadsheetCore} from './spreadsheetCore';

const core=createSpreadsheetCore();
export function spreadsheetToXlsx(value) {
    const workbook=XLSX.utils.book_new();
    getWorkbookSheets(value).forEach(({name,data})=>{
        const worksheet={},results=core.calculate(data.cellData);let maxRow=0,maxCol=0;
        Object.entries(data.cellData).forEach(([id,entry])=>{
            const coords=core.coords(id);if(!coords)return;
            const raw=entry?.value ?? '',result=Object.prototype.hasOwnProperty.call(results,id)?results[id]:raw;
            if(raw==='')return;
            maxRow=Math.max(maxRow,coords.row-1);maxCol=Math.max(maxCol,coords.col);
            const numeric=typeof result==='number'?result:core.number(result);
            worksheet[id]={t:entry.format==='text' || numeric===null?'s':'n',v:entry.format==='text' || numeric===null?String(result):numeric};
            if(String(raw).trim().startsWith('=') && entry.format!=='text')worksheet[id].f=String(raw).trim().slice(1);
        });
        worksheet['!merges']=Object.entries(data.mergedCells).flatMap(([id,merge])=>{
            const coords=core.coords(id);if(!coords)return [];
            const endRow=coords.row+Math.max(1,Number(merge.rowspan)||1)-2,endCol=coords.col+Math.max(1,Number(merge.colspan)||1)-1;
            maxRow=Math.max(maxRow,endRow);maxCol=Math.max(maxCol,endCol);
            return [{s:{r:coords.row-1,c:coords.col},e:{r:endRow,c:endCol}}];
        });
        worksheet['!ref']=XLSX.utils.encode_range({s:{r:0,c:0},e:{r:maxRow,c:maxCol}});
        worksheet['!cols']=Array.from({length:maxCol+1},(_,index)=>({wpx:Number(data.columnWidths[index])||80}));
        worksheet['!rows']=Array.from({length:maxRow+1},(_,index)=>({hpx:Number(data.rowHeights[index+1])||28}));
        const safeName=name.replace(/[\\/?*[\]:]/g,' ').slice(0,31) || 'Sheet';
        const usedNames=new Set(workbook.SheetNames.map(existing=>existing.toLowerCase()));
        let exportName=safeName,suffix=2;
        while(usedNames.has(exportName.toLowerCase()))exportName=safeName.slice(0,26)+' ('+(suffix++)+')';
        XLSX.utils.book_append_sheet(workbook,worksheet,exportName);
    });
    return workbook;
}
